export default __webpack_public_path__ + "static/media/multi_panel.4f171749.svg";